import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-invalid-file-type-modal',
  templateUrl: './invalid-file-type-modal.component.html',
  styleUrls: ['./invalid-file-type-modal.component.scss']
})
export class InvalidFileTypeModalComponent implements OnInit {

  invalidFileModalOptions: ModalOptions;
  hideModal: boolean;
  imgPath: string;
  @Output() closeInvalidFileTypeModal: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private acmicService: AcmicService
  ) { 
    this.hideModal = false;
  }

  hideModalAction(): void {
    this.hideModal = !this.hideModal;
    this.closeInvalidFileTypeModal.emit(true);
  }

  hideOnClick(event): void {
    if (!event.target.closest(".modal-body")) {
      this.hideModalAction();
    }
  }
  
  setModalOptions() {
    this.invalidFileModalOptions = new ModalOptions({
      additionalClasses: 'modal-medium modal-dialog center-on-page',
      modalId: 'invalidFileTypeModal',
      typeOfModal: 'default',
      modalName: 'invalid_file_type_modal',
      onLoad: true,
      animatePosition: 'top'
    }); 
  }
  setImagePath() {
    if(this.acmicService.isACMIC) {
      this.imgPath = 'assets/img/images/icon-warning-gray363636.svg';
    } else {
      this.imgPath = 'assets/img/images/icon-warning.svg';
    }
  }
  ngOnInit(): void {
    this.setModalOptions();
    this.setImagePath();
  }

}
